export default {"src":"/_next/static/media/neu.399a636a.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};